import history from 'history.js'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import PATH from '../../../business-const/Path/Path'

import LocalStorageService from '../../../business-api/LocalStorageService'

import {
    dataAtual,
    mes,
    dia,
    arrayDataToData,
    formataDataEmDiaMesComBarra,
    calculaIdadeFutura,
    somaDiasData,
} from '../../../business-components/Date/Date'

import {
    redirecionarClienteForm,
} from '../../clientes/ClienteListService'



export const calculaPotencialNegociosTotal = (clienteList) => {

    let potencialNegociosTotal = 0

    clienteList?.forEach( (linhaClienteList, indexClienteList) => {

        potencialNegociosTotal += linhaClienteList.potencialNegocios
    })

    return potencialNegociosTotal
}



export const redirecionaAgendaPageClienteList = ( variaveisGlobais, item ) => {

    LocalStorageService.setarDashboardSelecionado(LABEL.agenda, LABEL.agenda, LABEL.agenda, null)

    if (item) {

        redirecionarClienteForm(variaveisGlobais, item.idUsuario, item.idCliente, item.ultimaVersao, item.jsonComparacaoEstudos,
            item.ultimaVersao, null, null, null, null, false)

    } else {

        history.push(PATH.pageClienteList)
    }
}



export const redirecionaPendenciasComDataPrevistaPageClienteList = ( variaveisGlobais, item ) => {

    LocalStorageService.setarDashboardSelecionado(LABEL.pendenciasComDataPrevista, LABEL.pendenciasComDataPrevista,
        LABEL.pendenciasComDataPrevista, null)

    if (item) {

        redirecionarClienteForm(variaveisGlobais, item.idUsuario, item.idCliente, item.ultimaVersao, item.jsonComparacaoEstudos,
            item.ultimaVersao, null, null, null, null, false)

    } else {

        history.push(PATH.pageClienteList)
    }
}



export const redirecionaAniversarioPageClienteList = ( variaveisGlobais, item ) => {

    LocalStorageService.setarDashboardSelecionado(LABEL.aniversario, LABEL.aniversario, LABEL.aniversario, null)

    if (item) {

        redirecionarClienteForm(variaveisGlobais, item.idUsuario, item.idCliente, item.ultimaVersao, item.jsonComparacaoEstudos,
            item.ultimaVersao, null, null, null, null, false)

    } else {

        history.push(PATH.pageClienteList)
    }
}



export const redirecionaAportePageClienteList = ( variaveisGlobais, item ) => {

    LocalStorageService.setarDashboardSelecionado(LABEL.aporte, LABEL.aporte, LABEL.aporte, null)

    if (item) {

        redirecionarClienteForm(variaveisGlobais, item.idUsuario, item.idCliente, item.ultimaVersao, item.jsonComparacaoEstudos,
            item.ultimaVersao, null, null, null, null, false)

    } else {

        history.push(PATH.pageClienteList)
    }
}



export const redirecionaAportePageList = ( dataPrevistaAporte, naoExibirFiltros, exibirLinkDashboardAporte ) => {

    history.push({
        pathname: PATH.pageAporteList,
        dataPrevistaAporte: dataPrevistaAporte,
        naoExibirFiltros: naoExibirFiltros,
        exibirLinkDashboardAporte: exibirLinkDashboardAporte,
    })
}



export const calculaMesDiaAniversarioInicial = () => {

    return (mes(dataAtual()) * 100) + dia(dataAtual())
}

export const calculaDataAniversarioFinal = (diasAniversarioProximo) => {

    let dataAniversarioFinal = dataAtual()

    dataAniversarioFinal = somaDiasData(dataAniversarioFinal,
        diasAniversarioProximo ? diasAniversarioProximo : HARDCODE.diasAniversarioProximoAlerta)

    return dataAniversarioFinal
}

export const calculaMesDiaAniversarioFinal = (diasAniversarioProximo) => {

    const dataAniversarioFinal = calculaDataAniversarioFinal(diasAniversarioProximo)

    return (mes(dataAniversarioFinal) * 100) + dia(dataAniversarioFinal)
}

export const aniversarioProximo = (nascimento, mesDiaNascimento, diasAniversarioProximo) => {

    let aniversarioProximo = ''

    const mesDiaAniversarioInicial = calculaMesDiaAniversarioInicial()
    const mesDiaAniversarioFinal = calculaMesDiaAniversarioFinal(diasAniversarioProximo)

    if (nascimento) {

        if (
                (
                    mesDiaAniversarioInicial <= mesDiaAniversarioFinal &&
                    mesDiaNascimento >= mesDiaAniversarioInicial &&
                    mesDiaNascimento <= mesDiaAniversarioFinal
                ) ||
                (
                    mesDiaAniversarioInicial > mesDiaAniversarioFinal &&
                    (
                        mesDiaNascimento >= mesDiaAniversarioInicial ||
                        mesDiaNascimento <= mesDiaAniversarioFinal
                    )
                )
        ) {

            aniversarioProximo = formataDataEmDiaMesComBarra(arrayDataToData(nascimento))
        }
    }

    return aniversarioProximo
}

export const aniversarioProximoAlerta = (nascimento, mesDiaNascimento) => {

    return aniversarioProximo(nascimento, mesDiaNascimento, HARDCODE.diasAniversarioProximoAlerta)
}

export const aniversarioProximoLista = (nascimento, mesDiaNascimento) => {

    return aniversarioProximo(nascimento, mesDiaNascimento, HARDCODE.diasAniversarioProximoLista)
}

export const idadeAniversarioProximo = (nascimento) => {

    const dataAniversarioFinal = calculaDataAniversarioFinal(null)

    return calculaIdadeFutura (arrayDataToData(nascimento), dataAniversarioFinal)

}
export const calculaStatusDataAniversario = (mesDiaNascimentoCliente, diasAniversarioProximo) => {

    let statusDataAniversario

    const mesDiaAniversarioInicial = calculaMesDiaAniversarioInicial()
    const mesDiaAniversarioFinal = calculaMesDiaAniversarioFinal(diasAniversarioProximo)

    if (mesDiaNascimentoCliente === null) {

        statusDataAniversario = null

    } else {

        if (mesDiaAniversarioInicial <= mesDiaAniversarioFinal && mesDiaNascimentoCliente < mesDiaAniversarioInicial) {

            statusDataAniversario = HARDCODE.statusDataHoraPrevistaFunilEtapaAtrasado

        } else {

            if (mesDiaNascimentoCliente === mesDiaAniversarioInicial) {

                statusDataAniversario = HARDCODE.statusDataHoraPrevistaFunilEtapaHoje

            } else {

                statusDataAniversario = HARDCODE.statusDataHoraPrevistaFunilEtapaFuturo
            }
        }
    }

    return statusDataAniversario
}
